'use strict';
var globalThis = require('../internals/global-this');

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/environment-user-agent.js
// module id = 61
// module chunks = 13